/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import noUiSlider from "nouislider";
import PluginNoUiSlider from '../plugins/nouislider'

function initPartialOffersConfigEvents(){
    let $partial = $('.offer-config');
    if(!$partial.length){
        return;
    }

    let $configGroups = $partial.find('.config-group:not(.filter-container) input').change(function () {
        let name = $(this).attr('name').replace('SearchOfferForm[', '').replace(']', '');
        let value = $(this).val();

        $('body')
            .removeClassStartsWith('config-'+name)
            .addClass('config-'+name+'-'+value);

        $(this).closest('form').submit();
    });

    let $groupPrice = $partial.find('.group-price');
    let $input = $groupPrice.find('.range-value');

    let $isPro = (window.multisite || null) === 'vans';

    function getMinPrice()
    {
        return (!$isPro && $partial.find('.config-group.group-offer [name="SearchOfferForm[offer_type]"]:checked').val()=='personal' && $partial.find('.config-group.group-finance [name="SearchOfferForm[finance_type]"]:checked').val()=='rent')
        || ($isPro && $partial.find('.config-group.group-finance [name="SearchOfferForm[finance_type]"]:checked').val()=='rent')
            ? 1500
        : 1500;
    }

    let $config = {
        start: $input.val(),
        connect: 'lower',
        step: 500,
        range: {
            min: getMinPrice(),
            max: 3500
        },
        format: {
            to: function (value) {
                value = value.toFixed(0);
                if(value==3500){
                    value = 'max';
                }

                return value;
            },
            from: function (value) {
                if(value=='max'){
                    value = 3500;
                }

                return value;
            }
        },
    };
    let $el = $groupPrice.find('.range-slider')[0];
    if($el.noUiSlider){
        return;
    }

    noUiSlider.create($el, $config);

    $el.noUiSlider.on('update', function (values, handle, unencoded, tap, positions) {
        $input.val(values[0]);

        if(!$groupPrice.find('.noUi-touch-area span').length){
            $groupPrice.find('.noUi-touch-area').append($($el).data('lang-prefix')+'&nbsp;<span></span>');
        }
        let $label = values[0]=='max' ? $($el).data('lang-max') : values[0] + ' ' + $($el).data('lang-currency');
        $groupPrice.find('.noUi-touch-area span').html($label);

        PluginNoUiSlider.update($($el.noUiSlider.target), positions);
    });
    $el.noUiSlider.on('set', function (values, handle, unencoded, tap, positions) {
        $input.change();

        PluginNoUiSlider.update($($el.noUiSlider.target), positions);
    });
    $el.noUiSlider.on('slide', function (values, handle, unencoded, tap, positions) {
        PluginNoUiSlider.update($($el.noUiSlider.target), positions);
    });

    $(window).off('resize.offerConfig updateOfferConfig').on('resize.offerConfig updateOfferConfig', function () {
        $el.noUiSlider.updateOptions({});
    });

    $partial.on('change', '.config-group.group-offer [name="SearchOfferForm[offer_type]"], .config-group.group-finance [name="SearchOfferForm[finance_type]"]', function (){
        $el.noUiSlider.updateOptions({
            range: {
                min: getMinPrice(),
                max: 3500
            }
        });
    });
}

$(initPartialOffersConfigEvents);

export default initPartialOffersConfigEvents;